import api from '@/api'

export default {
  all: (filter) => api('get', '/status', filter),
  create: (data) => api('post', '/status', data),
  show: (id) => api('get', `/status/${id}`),
  delete: (id) => api('delete', `/status/${id}`),
  update: (data) => api('put', `/status/${data.id}`, data)
}
